"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EformPropertyDtoToEformPropertyState = void 0;
exports.EformPropertyDtoToEformPropertyState = function (lang) { return function (propertyDto) {
    var _a;
    var isEn = lang.toLowerCase().indexOf('en') > -1;
    var title = isEn ? [propertyDto.caption_2, propertyDto.title].filter(function (it) { return it; }).join(', ') : [propertyDto.titleChi, propertyDto.captionChi_2].filter(function (it) { return it; }).join();
    return {
        property_id: propertyDto.propertyId,
        bath: propertyDto.bathroom,
        beds: propertyDto.bedroom,
        buildingName: isEn ? propertyDto.buildingNameEng : propertyDto.buildingNameChi,
        imageUrl: propertyDto.photoName.indexOf("nophoto") >= 0 ? "" : propertyDto.photoName,
        isNetSize: propertyDto.netSize > 0,
        price: propertyDto.salePrice > 0 ? propertyDto.salePrice : propertyDto.leasePrice,
        size: propertyDto.netSize > 0 ? propertyDto.netSize : (propertyDto.grossSize > 0 ? propertyDto.grossSize : 0),
        title: title,
        type: (_a = propertyDto.postingPurposeId) !== null && _a !== void 0 ? _a : null,
        caption: isEn ? propertyDto.caption_2 : propertyDto.captionChi_2,
        address: isEn ? propertyDto.caption_1 : propertyDto.captionChi_1,
        eforms: [],
        isExpanded: false,
        isLoading: true,
    };
}; };
